import useAllTimePreset from '@/hooks/useAllTimePreset';
import { isOverAYearApart } from '@/utils';
import type { DateRange } from '@/types';

/**
 * Returns `true` when the All time preset is enabled and the download range spans more than a
 * year, meaning downloads are limited to the total breakdown.
 * TODO: once `allTimePreset` is enabled for everyone, drop the flag check and replace this hook
 * with a direct `isOverAYearApart` call in the drawers.
 */
const useIsDownloadRangeRestricted = (dateRange: DateRange): boolean =>
  useAllTimePreset() && isOverAYearApart(dateRange.from, dateRange.to);

export default useIsDownloadRangeRestricted;
